export const PLATFORM_GUIDE_OG_IMAGE = "/images/platform-guides-og.jpg"

export const platforms = [
  {
    name: "Pinterest",
    slug: "pinterest",
    desc: "Ads & Shopping Catalogs",
    relatedSlugs: ["meta", "google", "tiktok"],
  },
  {
    name: "Meta & Instagram",
    slug: "meta",
    desc: "Meta & Instagram Dynamic Ads",
    relatedSlugs: ["pinterest", "tiktok", "snapchat"],
  },
  {
    name: "Google Merchant Center",
    slug: "google",
    desc: "Google Shopping & Performance Max",
    relatedSlugs: ["microsoft-ads", "idealo", "pinterest"],
  },
  {
    name: "Microsoft Ads",
    slug: "microsoft-ads",
    desc: "Bing Shopping Campaigns",
    relatedSlugs: ["google", "idealo"],
  },
  {
    name: "TikTok Shopping Ads",
    slug: "tiktok",
    desc: "TikTok Product Catalog & Dynamic Ads",
    relatedSlugs: ["snapchat", "meta", "pinterest"],
  },
  {
    name: "Snapchat Dynamic Ads",
    slug: "snapchat",
    desc: "Snapchat Catalog & Dynamic Ads",
    relatedSlugs: ["tiktok", "meta", "pinterest"],
  },
  {
    name: "Criteo",
    slug: "criteo",
    desc: "Dynamic Retargeting",
    relatedSlugs: ["google", "meta", "klaviyo"],
  },
  {
    name: "Klaviyo",
    slug: "klaviyo",
    desc: "Email & SMS Product Recommendations",
    relatedSlugs: ["meta", "google", "criteo"],
  },
  {
    name: "Awin",
    slug: "awin",
    desc: "Affiliate Network Product Feeds",
    relatedSlugs: ["idealo", "google"],
  },
  {
    name: "Idealo Sponsored Products",
    slug: "idealo",
    desc: "Price Comparison & Sponsored Listings",
    relatedSlugs: ["google", "microsoft-ads", "awin"],
  },
]

export const getPlatformBySlug = slug =>
  platforms.find(platform => platform.slug === slug)

export const getRelatedPlatforms = slug => {
  const platform = getPlatformBySlug(slug)
  if (!platform) return []

  return platform.relatedSlugs
    .map(relatedSlug => getPlatformBySlug(relatedSlug))
    .filter(Boolean)
}
